<template>
    <div class="documents" :class="{'ac-bg-gray': ac}">
        <header-component :is-soon="false" :backRoute="true" img-left="/trocachip/img/setinha-left-preto.svg" img-right="/trocachip/img/access.png" class="header-component" />
        <div :class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"></div>
        <div class="container">
            <h2 class="documents_title" :class="{'ac-color-white': ac}" v-html="pageInfo.title">
            </h2>

            <section class="info_card" id="infocard">
                <section class="card_type_title">
                    <img src="../../public/img/ic-exclamation-yellow.svg" alt="alert"/>
                    <p v-html="pageInfo.yellowCardTitle"></p>
                </section>
                <section class="documents_description">
                    <p v-html="pageInfo.yellowCardMessage"></p>
                </section>
                <section class="documents_description"  :class="{'ac-bg-black': ac, 'ac-color-yellow': ac}">
                    <p>{{pageInfo.phoneNumberTitle}}<strong>({{ customer.login.slice(0,2)}}) {{customer.login.slice(2,7)}}-{{customer.login.slice(7,12)}}</strong></p>
                </section>
            </section>

            <section class="documents_number">
                <label :class="{'ac-color-white': ac}">{{pageInfo.cpfHeader}}</label>
                <input id="cpffield" type="text" @blur="checkCpf()" @keydown="cleanErrors()" v-mask="'###.###.###-##'" :placeholder="cpfInputPlaceholder" v-model="cpf" :class="{'ac-color-white': ac, 'ac-input': ac}">
                <span id="errorincompletecpf" v-show="errors.incomplete" class="error-danger" :class="{'ac-color-yellow': ac}">{{ pageInfo.incompleteCpfError }}</span>
                <span v-show="!errors.invalid && !errors.incomplete" class="error-danger" :class="{'ac-color-yellow': ac}">{{ pageInfo.invalidCpfError }}</span>
            </section>
            <div class="next_submit">
                <button id="submitdocument" class="btn_next" :class="{ 'btn_next_active' : isValid, 'ac-border-yellow': ac, 'ac-color-yellow': ac, 'ac-bg-gray': ac }" :disabled="!isValid" @click="next">
                    <loader-bottom v-if="loader"/>
                    <span v-if="!loader">Continuar</span>
                </button>
            </div>
        </div>
        <alert
                description="CPF Inválido"
                danger="true"
                message="O CPF digitado é inválido, por favor, verifique o número digitado"
                v-on:close="alert = !alert"
                v-if="alert"
        >
        </alert>
        <alert
                :description="validate.cpf.descErro"
                :action="validate.cpf.button"
                danger="true"
                :message="validate.cpf.errorDescription"
                v-on:close="cpfValidate = !cpfValidate"
                :tracker="validate.cpf.tracker"
                v-if="cpfValidate"
        >
        </alert>

        <alert 
            v-if="ineligibleModal.active"
            danger="true"
            :description="ineligibleModal.title"
            :action="ineligibleModal.action"
            v-on:close="ineligibleModal.actionTrigger()"
        />
    </div>
</template>

<script>
    import HeaderComponent from "../components/HeaderComponent";
    import LoaderBottom from "../components/LoaderBottom";
    import Alert from "../components/Alert";
    import trackEvent from "../services/trackEvent";
    import  Cpf  from "../services/cpf";
    import { mapState } from 'vuex';
    import { cpf } from 'cpf-cnpj-validator';
    import { webCrypto } from '../utils/aesencryption';

    export default {
        name: "Documents",
        components: {
            HeaderComponent,
            Alert,
            LoaderBottom
        },
        computed: {
            ...mapState({
                ac: state => state.ac,
                document: state => state.document,
                config: state => state.config,
                customer: state => state.customer,
                cpfConsultErrors: state => state.cpfConsultErrors,
                genericCpfError: state => state.config.generic_cpf_error_modal
            })
        },
        data() {
            return {
                cpf: '',
                errors: {
                    incomplete: false,
                    invalid: true,
                },
                isValid: false,
                alert: false,
                cpfValidate: false,
                validate: {
                    cpf: {
                        descErro: '',
                        errorDescription: '',
                        tracker: ''
                    }
                },
                ineligibleModal: {
                    active: false
                },
                loader: false,
                pageInfo: {
                    "title": "Ativar novo TIM chip 4G",
                    "midPageMessage": "Para os próximos passos  você precisa ter em mãos  o seu novo TIM chip 4G",
                    "cpfHeader": "Informe o seu CPF",
                    "phoneNumberTitle": "Seu número da TIM é:"
                },
                cpfInputPlaceholder: ''
            }
        },
        async created() {
            this.cpf = this.document
            this.pageInfo = !this.isExOi() ? this.config.validation : this.pageInfo;
            this.cpfInputPlaceholder = this.config.cpf_registration_placeholder;
            this.sendTrackerClientInelegible('confirmar email')
              
            
        },
        watch: {
            cpf: function() {
                if (this.cpf.length === 14) {
                    this.errors.incomplete = this.cpf.length > 0 && this.cpf.length < 14;
                    this.errors.invalid = cpf.isValid(this.cpf.replace(/[^\d]+/g,''));
                    this.isValid = this.errors.invalid && !this.errors.incomplete;
                }
            }
        },
        methods: {
            checkCpf() {
                this.errors.incomplete = this.cpf.length > 0 && this.cpf.length < 14;
                this.errors.invalid = cpf.isValid(this.cpf.replace(/[^\d]+/g,''));
                this.isValid = this.errors.invalid && !this.errors.incomplete;
            },
            cleanErrors() {
              this.errors.incomplete = false;
              this.errors.invalid = false;
            },
            async next() {
                this.loader = true;
                const key = process.env.VUE_APP_CONFIG_AES_CRYPT_KEY;
                const cipherText = await webCrypto.simpleEncrypt(this.cpf.replace(/[^\d]+/g,''), key);
                Cpf.Validate(cipherText, this.$store.getters.getFlowSelected).then( async () => {
                    this.loader = false;
                    await this.track();
                    await this.$store.dispatch('document', this.cpf);

                    return this.$router.push('/codigo');
                }).catch(async (error) => {
                    const response = error.response;

                    if (response.data.internalCode == "-40004") {
                        this.treat40004Error();
                        return;
                    }

                    if(response.data.internalCode == "-40000") {
                        this.treat40000Error();
                        return;
                    }

                    if (response.data.internalCode == "-40008") {
                         trackEvent.track({
                            'user': {
                                'login': this.customer.login,
                                'loginType':  '',
                                'lineType':  this.customer.loginType,
                                'segment': this.customer.segment,
                                'subSegment':  this.customer.subSegment,
                                'planCode': this.customer.planCode,
                                'planName':  this.customer.planName
                            },
                            'channel': trackEvent.getChannel(),
                            'event-category': 6,
                            'event-label': 'screen_erro_cpf_plano_nao_atendido',
                            'event-value': 'mvp esim',
                            'event-status': 'Falha',
                            'event-interactionNumber': '',
                            'event-error': '',
                            'event-errorDetail': ''
                        })
                        this.clientNotEligible();
                        return;
                    }

                    await this.track();
                    this.cpfDefaultErrorCase();
                    await this.$store.dispatch('document', this.cpf);
                }).catch( () => {
                    this.cpfDefaultErrorCase()
                })
            },
            async cpfDefaultErrorCase() {
                this.loader = false;
                this.validate.cpf.descErro = this.genericCpfError.title;
                this.validate.cpf.errorDescription = this.genericCpfError.description
                this.validate.cpf.button = this.genericCpfError.button
                this.cpfValidate = true;
                return;
            },
            async treat40000Error() {
                if (this.cpfConsultErrors >= 2) {
                    this.exceedCpfErrors();
                    return;
                }
                this.validate.cpf.descErro = this.config.cpf_nao_identificado_error_modal.title;
                this.validate.cpf.errorDescription = this.config.cpf_nao_identificado_error_modal.description
                this.validate.cpf.button = this.config.cpf_nao_identificado_error_modal.button
                this.validate.cpf.tracker =  this.config.cpf_nao_identificado_error_modal.tracker
                this.loader = false;
                this.alert = true;
                await this.$store.dispatch('cpfConsultErrors',  this.cpfConsultErrors + 1);
                trackEvent.track({
                    'user': {
                        'login': this.customer.login,
                        'loginType':  '',
                        'lineType':  this.customer.loginType,
                        'segment': this.customer.segment,
                        'subSegment':  this.customer.subSegment,
                        'planCode': this.customer.planCode,
                        'planName':  this.customer.planName
                    },
                    'channel': trackEvent.getChannel(),
                    'event-category': 6,
                    'event-label': 'screen_erro_cpf_cpf_nao_identificado',
                    'event-value': null,
                    'event-status': 'Falha',
                    'event-interactionNumber': '',
                    'event-error': '',
                    'event-errorDetail': ''
                })
            },
            async treat40004Error() {
                this.loader = false;
                if (this.cpfConsultErrors >= 2) {
                    this.exceedCpfErrors();
                    return
                }
                this.validate.cpf.descErro = this.config.cpf_nao_cadastrado_error_modal.title;
                this.validate.cpf.errorDescription = this.config.cpf_nao_cadastrado_error_modal.description
                this.validate.cpf.button = this.config.cpf_nao_cadastrado_error_modal.button
                this.validate.cpf.tracker =  this.config.cpf_nao_cadastrado_error_modal.tracker
                this.cpfValidate = true;
                await this.$store.dispatch('cpfConsultErrors',  this.cpfConsultErrors + 1);
                trackEvent.track({
                    'user': {
                        'login': this.customer.login,
                        'loginType':  '',
                        'lineType':  this.customer.loginType,
                        'segment': this.customer.segment,
                        'subSegment':  this.customer.subSegment,
                        'planCode': this.customer.planCode,
                        'planName':  this.customer.planName
                    },
                    'channel': trackEvent.getChannel(),
                    'event-category': 6,
                    'event-label': 'screen_erro_cpf_cpf_nao_cadastrado',
                    'event-value': null,
                    'event-status': 'Falha',
                    'event-interactionNumber': '',
                    'event-error': '',
                    'event-errorDetail': ''
                })
            },
            clientNotEligible() {
                
                this.ineligibleModal.title = "Para fazer a troca de tecnologia do seu plano procure uma loja TIM",
                this.ineligibleModal.action = "Localize uma loja";
                this.ineligibleModal.actionTrigger = () => {
                    this.redirectClientToStoreLocation() 
                    this.sendTrackerClientInelegible('tentar_novamente_cpf_plano_nao_atendido')};
                this.ineligibleModal.active = true;
                return;
            },
            redirectClientToStoreLocation() {
                window.location.replace(this.config.locate_tim_stores_url);
            },
            redirectToHome() {
                this.$store.dispatch("cleanCustomerInfos");
                this.$store.dispatch("cpfConsultErrors", 0);
                this.$router.push({ name: "welcome" });
            },
            exceedCpfErrors() {
                this.ineligibleModal.title = "Seu cadastro não pode ser realizado com este CPF",
                this.ineligibleModal.action = "Ok, entendi";
                this.ineligibleModal.actionTrigger = () => this.redirectToHome();
                this.ineligibleModal.active = true;
                return;
            },
            track(status = "Sucesso") {
                trackEvent.track({
                    'user': {
                        'login': this.customer.login,
                        'loginType':  '',
                        'lineType':  this.customer.loginType,
                        'segment': this.customer.segment,
                        'subSegment':  this.customer.subSegment,
                        'planCode': this.customer.planCode,
                        'planName':  this.customer.planName
                    },
                    'channel': trackEvent.getChannel(),
                    'event-category': 6,
                    'event-action': '2',
                    'event-label': 'Troca de Chip CPF',
                    'event-value': null,
                    'event-status': status,
                    'event-interactionNumber': '',
                    'event-error': '',
                    'event-errorDetail': ''
                })
            },
            sendTrackerClientInelegible(eventLabel){
                trackEvent.track({
                        'user': {
                            'login': this.customer.login,
                            'loginType':  this.customer.loginType,
                            'lineType':  this.customer.lineType,
                            'segment': this.customer.segment,
                            'subSegment':  this.customer.subSegment,
                            'planCode': this.customer.planCode,
                            'planName':  this.customer.planName
                        },
                        'channel': trackEvent.getChannel(),
                        'event-category': 6,
                        'event-label': eventLabel,
						'event-location': 'mvp esim',
                        'event-value': this.isExOi() ? 'oi' : 'tim',
                        'event-status': 'Sucesso',
                    })
            },
            isExOi() {
			if (this.config['init_flow'] === undefined) {
				this.alertError = true;
			}

			return JSON.parse(this.customer.isExOiCustomer);
		}
            
        }
    }
</script>

<style lang="scss" scoped>
    .documents {
        width: 100%;
        height: 100%;
        display: block;
        position: fixed;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;
        .background-desktop {
            display: none;
        }
        > .container {
            > .info_card {
                border: 1px solid #E0E0E0;
                border-radius: 8px;
                box-sizing: border-box;
                border-left: 5px solid #F4B136;
                padding-left: 20px;
                padding-right: 20px;
                margin: 0 auto;
                > .card_type_title {
                    display: flex;
                    flex-direction: row;
                    margin: 10px 0;
                    > p {
                        color: #F4B136;
                        font-size: 0.75em;
                        font-family: "timsans_bold";
                        padding-left: 8px;
                    }
                }
                > .documents_description {
                    display: block;
                    position: relative;
                    font-family: "timsans_regular";
                    font-size: 0.875em;
                    line-height: 1.43;
                    letter-spacing: normal;
                    color: #707376;
                }
            }
            > .documents_title {
                width: 100%;
                height: auto;
                display: block;
                position: relative;
                margin-top: 96px;
                font-family: 'timsans_regular';
                font-weight: 300;
                font-size: 1.688em;
                line-height: 1.11;
                letter-spacing: normal;
                text-align: center;
                color: #000000;
            }
            > section .documents_phone_number {
                width: 252px;
                height: 72px;
                margin: 48px auto 0 auto;
                display: flex;
                flex-wrap: wrap;
                position: relative;
                border-radius: 55px;
                background-color: #f3f3f3;
                text-align: center;
                font-family: "timsans_regular";
                > span {
                    width: 100%;
                    height: auto;
                    font-family: "timsans_regular";
                    margin: 12px auto 4px auto;
                    font-size: 0.75em;
                }
                > p {
                    width: 100%;
                    height: auto;
                    margin: 4px auto 12px auto;
                    font-size: 1em;
                    font-family: "timsans_regular";
                }
            }
            > .documents_number {
                width: 252px;
                height: auto;
                display: block;
                margin: 32px auto 0 auto;
                position: relative;
                > label {
                    width: 100%;
                    height: 15px;
                    font-family: 'timsans_regular';
                    font-size: 0.75em;
                    color: #6c6c6c;
                }
                > input {
                    font-size: 12px;
                    color: #B3B3B3;
                }
                > img{
                    position: absolute;
                    top: 52%;
                    right: 0;
                }
            }
        }
    }
    @media (min-width: 768px) {
        .documents {
            width: 100%;
            height: 100%;
            display: grid;
            grid-auto-columns: 50% 50%;
            grid-template-areas:
                    'header header'
                    'container background';
            z-index: -1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-y: auto;

            .header-component {
                width: 45%;
                grid-area: header;
            }

            .background-desktop {
                grid-area: background;
                width: 100%;
                height: 100vh;
                display: block;
                background: url("../assets/images/desktop@3x.png") no-repeat;
                background-size: cover;
            }

            .background-desktop-black {
                grid-area: background;
                width: 100%;
                height: 100vh;
                display: block;
                background: url("../assets/images/desktop-black.png") no-repeat;
                background-size: cover;
            }

            .container {
                grid-area: container;
                > .documents_title {
                    width: 400px;
                    height: auto;
                    display: block;
                    margin: 115px auto 0 auto;
                    font-family: 'timsans_thin';
                    font-size: 2em;
                    font-weight: normal;
                    line-height: 1.2;
                }
                > section .documents_phone_number {
                    width: 400px;
                    height: 72px;
                    margin: 48px auto 0 auto;
                    display: flex;
                    flex-wrap: wrap;
                    position: relative;
                    border-radius: 55px;
                    background-color: #f3f3f3;
                    text-align: center;
                    font-family: "timsans_regular";
                    > span {
                        width: 100%;
                        height: auto;
                        font-family: "timsans_regular";
                        margin: 12px auto 4px auto;
                        font-size: 0.75em;
                    }
                    > p {
                        width: 100%;
                        height: auto;
                        margin: 4px auto 12px auto;
                        font-size: 1em;
                        font-family: "timsans_regular";
                    }
                }
                > section .documents_description {
                    width: 400px;
                    height: auto;
                    display: none;
                    position: relative;
                    margin: 0 auto;
                    font-family: "timsans_regular";
                    font-size: 1em;
                    line-height: 1.43;
                    letter-spacing: normal;
                    text-align: center;
                    color: #919191;
                }
                > .documents_number {
                    width: 400px;
                    height: auto;
                    display: block;
                    margin: 32px auto 0 auto;
                    > label {
                        width: 100%;
                        height: 15px;
                        font-family: 'timsans_regular';
                        font-size: 0.75em;
                        color: #6c6c6c;
                    }
                }
            }
        }
    }
</style>